export type Language = 'en' | 'sw' | 'ar';

export const translations: Record<Language, Record<string, string>> = {
  en: {
    find_rides: 'Find Rides',
    update_ready_msg: 'A new version is ready.',
    update_restart_btn: 'Restart',
    enable_push_prompt_title: 'Turn on trip alerts',
    enable_push_prompt_body: 'Allow notifications so you never miss when your driver accepts, arrives, or your trip starts.',
    enable_push_prompt_cta: 'Allow notifications',
    enable_push_prompt_later: 'Not now',
    enable_push_prompt_denied: 'Notifications are blocked. Open Settings → Apps → SafariCab → Notifications and turn them on.',
    where_to: 'Where to?',
    current_location: 'Current location',
    detecting_location: 'Detecting your location…',
    choose_a_ride: 'Choose a ride',
    confirm_ride: 'Confirm Ride',
    cancel: 'Cancel',
    cancel_ride: 'Cancel Ride',
    keep_ride: 'Keep Ride',
    searching: 'Searching...',
    booking: 'Booking...',
    finding_rides: 'Finding rides...',
    driver_found: 'Driver found!',
    driver_on_the_way: 'Driver is on the way',
    driver_arrived: 'Your driver has arrived!',
    heading_to_destination: 'Heading to your destination',
    finding_another_driver: 'Finding another driver…',
    looking_for_driver: 'Looking for your driver…',
    add_stop: 'Add Stop',
    share_my_trip: 'Share my trip',
    add_a_stop: 'Add a stop (fare adjusts by distance)',
    edit_dropoff: 'Edit drop-off location',
    book_for_other: 'Booking for someone else?',
    logout: 'Logout',
    history: 'History',
    payment_methods: 'Payment Methods',
    wallet: 'Wallet',
    activity: 'Activity',
    notifications: 'Notifications',
    profile: 'Profile',
    saved_places: 'Saved Places',
    emergency_contacts: 'Emergency Contacts',
    invite_earn: 'Invite & Earn',
    spin_and_win: 'Spin & Win',
    home: 'Find Rides',
    arriving_now: 'Arriving now',
    schedule_later: 'Schedule for later (optional - prepaid by card)',
    discount_code: 'Discount code',
    apply: 'Apply',
    drivers_online_one: 'driver online',
    drivers_online_many: 'drivers online',
    change: 'Change',
    select_this_ride: 'Select This Ride',
    currently_busy: 'Currently Busy, Try Again Later',
    go_back: 'Go Back',
    fuel_type: 'Fuel Type',
    passengers_label: 'Passengers',
    goods_label: 'Goods',
    surge_pricing: 'Surge Pricing',
    surge_pricing_info: 'Prices may increase during peak hours, bad weather, or high demand. The final fare is always shown before you confirm.',
    safety_tip: 'Safety Tip',
    close: 'Close',
    language: 'Language',
    search_destination: 'Search destination...',
    no_results: 'No results found. Try a different search.',
    recent_places: 'Recent places',
    suggestions_near_you: 'Suggestions near you',
    home_label: 'Home',
    work_label: 'Work',
    set_address: 'Set address',
    confirm_cancel: 'Confirm Cancel',
    why_cancelling: "Please tell us why you're cancelling",
    submit_rating: 'Submit Rating',
    how_was_trip: 'How was your trip?',
    how_was_last_trip: 'How was your last trip?',
    skip: 'Skip',
    sit_back: 'Sit back and enjoy the ride',
    arrive_by: 'Arrive by',
    emergency_cancel: 'Emergency Cancel',
    view_details: 'View details ›',
    available: 'Available',
    busy_badge: 'Busy',
  },
  sw: {
    find_rides: 'Tafuta Usafiri',
    update_ready_msg: 'Toleo jipya liko tayari.',
    update_restart_btn: 'Anzisha upya',
    enable_push_prompt_title: 'Washa arifa za safari',
    enable_push_prompt_body: 'Ruhusu arifa ili usikose dereva akikubali, akifika, au safari yako ikianza.',
    enable_push_prompt_cta: 'Ruhusu arifa',
    enable_push_prompt_later: 'Si sasa',
    enable_push_prompt_denied: 'Arifa zimezuiwa. Fungua Mipangilio → Programu → SafariCab → Arifa na uziwashe.',
    where_to: 'Unakwenda wapi?',
    current_location: 'Mahali ulipo',
    detecting_location: 'Inatafuta mahali ulipo…',
    choose_a_ride: 'Chagua usafiri',
    confirm_ride: 'Thibitisha Safari',
    cancel: 'Ghairi',
    cancel_ride: 'Ghairi Safari',
    keep_ride: 'Endelea na Safari',
    searching: 'Inatafuta...',
    booking: 'Inaweka...',
    finding_rides: 'Inatafuta usafiri...',
    driver_found: 'Dereva amepatikana!',
    driver_on_the_way: 'Dereva yuko njiani',
    driver_arrived: 'Dereva wako amefika!',
    heading_to_destination: 'Unaelekea sehemu unayokwenda',
    finding_another_driver: 'Inatafuta dereva mwingine…',
    looking_for_driver: 'Inatafuta dereva wako…',
    add_stop: 'Ongeza Kituo',
    share_my_trip: 'Shiriki safari yangu',
    add_a_stop: 'Ongeza kituo (nauli huongezeka kwa umbali)',
    edit_dropoff: 'Badilisha mahali pa kushuka',
    book_for_other: 'Unaweka kwa mtu mwingine?',
    logout: 'Toka',
    history: 'Historia',
    payment_methods: 'Njia za Malipo',
    wallet: 'Pochi',
    activity: 'Shughuli',
    notifications: 'Arifa',
    profile: 'Wasifu',
    saved_places: 'Sehemu Zilizohifadhiwa',
    emergency_contacts: 'Anwani za Dharura',
    invite_earn: 'Alika na Upate',
    spin_and_win: 'Zungusha na Ushinde',
    home: 'Tafuta Usafiri',
    arriving_now: 'Anafika sasa',
    schedule_later: 'Panga baadaye (hiari - lipiwa kwa kadi)',
    discount_code: 'Msimbo wa punguzo',
    apply: 'Tumia',
    drivers_online_one: 'dereva mtandaoni',
    drivers_online_many: 'madereva mtandaoni',
    change: 'Badilisha',
    select_this_ride: 'Chagua Safari Hii',
    currently_busy: 'Iko Shughuli, Jaribu Baadaye',
    go_back: 'Rudi Nyuma',
    fuel_type: 'Aina ya Mafuta',
    passengers_label: 'Abiria',
    goods_label: 'Mizigo',
    surge_pricing: 'Bei ya Juu',
    surge_pricing_info: 'Bei inaweza kuongezeka wakati wa saa za msongamano, mvua, au mahitaji makubwa. Nauli ya mwisho huonyeshwa kabla ya kuthibitisha.',
    safety_tip: 'Ushauri wa Usalama',
    close: 'Funga',
    language: 'Lugha',
    search_destination: 'Tafuta mahali unakokwenda...',
    no_results: 'Hakuna matokeo. Jaribu utafutaji tofauti.',
    recent_places: 'Maeneo ya hivi karibuni',
    suggestions_near_you: 'Mapendekezo karibu nawe',
    home_label: 'Nyumbani',
    work_label: 'Kazini',
    set_address: 'Weka anwani',
    confirm_cancel: 'Thibitisha Kughairi',
    why_cancelling: 'Tafadhali tuambie kwa nini unaghairi',
    submit_rating: 'Tuma Ukadiriaji',
    how_was_trip: 'Safari ilikuwaje?',
    how_was_last_trip: 'Safari yako ya mwisho ilikuwaje?',
    skip: 'Ruka',
    sit_back: 'Starehe na ufurahie safari',
    arrive_by: 'Fika kabla ya',
    emergency_cancel: 'Ghairi Dharura',
    view_details: 'Ona maelezo ›',
    available: 'Inapatikana',
    busy_badge: 'Iko Shughuli',
  },
  ar: {
    find_rides: 'البحث عن رحلة',
    update_ready_msg: 'إصدار جديد جاهز.',
    update_restart_btn: 'إعادة التشغيل',
    enable_push_prompt_title: 'تفعيل تنبيهات الرحلة',
    enable_push_prompt_body: 'اسمح بالإشعارات حتى لا تفوتك لحظة قبول السائق أو وصوله أو بدء رحلتك.',
    enable_push_prompt_cta: 'السماح بالإشعارات',
    enable_push_prompt_later: 'ليس الآن',
    enable_push_prompt_denied: 'الإشعارات محظورة. افتح الإعدادات ← التطبيقات ← SafariCab ← الإشعارات وفعّلها.',
    where_to: 'إلى أين؟',
    current_location: 'موقعك الحالي',
    detecting_location: 'جارٍ تحديد موقعك…',
    choose_a_ride: 'اختر رحلة',
    confirm_ride: 'تأكيد الرحلة',
    cancel: 'إلغاء',
    cancel_ride: 'إلغاء الرحلة',
    keep_ride: 'إبقاء الرحلة',
    searching: 'جارٍ البحث...',
    booking: 'جارٍ الحجز...',
    finding_rides: 'جارٍ البحث عن رحلات...',
    driver_found: 'تم العثور على سائق!',
    driver_on_the_way: 'السائق في الطريق إليك',
    driver_arrived: 'وصل سائقك!',
    heading_to_destination: 'في الطريق إلى وجهتك',
    finding_another_driver: 'جارٍ البحث عن سائق آخر…',
    looking_for_driver: 'جارٍ البحث عن سائقك…',
    add_stop: 'إضافة محطة',
    share_my_trip: 'مشاركة رحلتي',
    add_a_stop: 'إضافة محطة (تُعدَّل الأجرة حسب المسافة)',
    edit_dropoff: 'تعديل موقع الإنزال',
    book_for_other: 'الحجز لشخص آخر؟',
    logout: 'تسجيل الخروج',
    history: 'السجل',
    payment_methods: 'طرق الدفع',
    wallet: 'المحفظة',
    activity: 'النشاط',
    notifications: 'الإشعارات',
    profile: 'الملف الشخصي',
    saved_places: 'الأماكن المحفوظة',
    emergency_contacts: 'جهات اتصال الطوارئ',
    invite_earn: 'ادعُ واكسب',
    spin_and_win: 'أدر واربح',
    home: 'البحث عن رحلة',
    arriving_now: 'يصل الآن',
    schedule_later: 'جدولة لاحقاً (اختياري - مدفوعة مسبقاً بالبطاقة)',
    discount_code: 'رمز الخصم',
    apply: 'تطبيق',
    drivers_online_one: 'سائق متاح',
    drivers_online_many: 'سائقون متاحون',
    change: 'تغيير',
    select_this_ride: 'اختر هذه الرحلة',
    currently_busy: 'مشغول حالياً، حاول لاحقاً',
    go_back: 'رجوع',
    fuel_type: 'نوع الوقود',
    passengers_label: 'الركاب',
    goods_label: 'البضائع',
    surge_pricing: 'أسعار الذروة',
    surge_pricing_info: 'قد ترتفع الأسعار خلال ساعات الذروة أو سوء الأحوال الجوية أو الطلب العالي. تُعرض الأجرة النهائية دائماً قبل التأكيد.',
    safety_tip: 'نصيحة أمان',
    close: 'إغلاق',
    language: 'اللغة',
    search_destination: 'ابحث عن وجهة...',
    no_results: 'لا توجد نتائج. جرّب بحثاً مختلفاً.',
    recent_places: 'الأماكن الأخيرة',
    suggestions_near_you: 'اقتراحات بالقرب منك',
    home_label: 'المنزل',
    work_label: 'العمل',
    set_address: 'تعيين عنوان',
    confirm_cancel: 'تأكيد الإلغاء',
    why_cancelling: 'الرجاء إخبارنا بسبب إلغائك',
    submit_rating: 'إرسال التقييم',
    how_was_trip: 'كيف كانت رحلتك؟',
    how_was_last_trip: 'كيف كانت رحلتك الأخيرة؟',
    skip: 'تخطي',
    sit_back: 'استرِح واستمتع بالرحلة',
    arrive_by: 'الوصول بحلول',
    emergency_cancel: 'إلغاء طارئ',
    view_details: '‹ عرض التفاصيل',
    available: 'متاح',
    busy_badge: 'مشغول',
  },
};

export function getTranslation(lang: Language, key: string): string {
  return translations[lang]?.[key] ?? translations.en[key] ?? key;
}
